<template>
  <div id="wrapper">
    <SidebarView :budgets="true" :budgetsList="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="container">
          <div class="card card-shape home-box">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-12">
                  <h6 class="m-0 fw-bold text-green">Budgets</h6>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-3 mb-3">
                <div class="col-md-4">
                  <label class="form-label small fw-bold">Financial Year</label>
                  <select v-model="filters.financial_year_id" class="form-select form-select-sm">
                    <option value="">All</option>
                    <option v-for="fy in financialYears" :key="fy.id" :value="String(fy.id)">
                      {{ fy.start_date }} → {{ fy.end_date }} ({{ fy.status }})
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label small fw-bold">Status</label>
                  <select v-model="filters.status" class="form-select form-select-sm">
                    <option value="">All</option>
                    <option value="draft">Draft</option>
                    <option value="approved">Approved</option>
                    <option value="locked">Locked</option>
                  </select>
                </div>
                <div class="col-md-4 d-flex align-items-end">
                  <b-button class="btn akkurate-green-btn text-white btn-size" @click="loadBudgets">
                    Refresh
                  </b-button>
                  <a
                    v-if="canManage"
                    href="/budgets/new"
                    class="btn akkurate-green-btn text-white btn-size ms-2"
                  >
                    Create Budget
                  </a>
                </div>
              </div>

              <b-alert v-if="!canManage && !canApprove" show variant="danger">
                No access: you do not have permission to manage budgets.
              </b-alert>

              <b-alert v-if="noAccess" show variant="danger">
                Access Denied! You do not have the necessary permissions to view this page.
              </b-alert>

              <b-table
                v-else
                :items="items"
                :fields="fields"
                striped
                responsive
                small
                :busy.sync="isBusy"
              >
                <template #cell(actions)="{ item }">
                  <a class="text-decoration-none akkurate-green me-2" :href="`/budgets/${item.id}`">Details</a>
                  <a
                    v-if="canManage"
                    class="text-decoration-none akkurate-green"
                    :href="`/budgets/${item.id}/lines`"
                  >
                    Lines
                  </a>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ApiService from "@/core/services/api.service";
import { hasPermission } from "@/helper";

export default {
  name: "BudgetsIndex",
  components: { SidebarView, TopbarView },
  data() {
    return {
      isBusy: false,
      noAccess: false,
      financialYears: [],
      filters: {
        financial_year_id: "",
        status: "",
        per_page: 50,
      },
      fields: [
        { key: "name", label: "Name" },
        { key: "financial_year_id", label: "Financial Year ID" },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],
      items: [],
    };
  },
  created() {
    this.loadFinancialYears();
    this.loadBudgets();
  },
  computed: {
    canManage() {
      return hasPermission("budgets_manage");
    },
    canApprove() {
      return hasPermission("budgets_approve_lock");
    },
  },
  methods: {
    async loadBudgets() {
      this.isBusy = true;
      this.noAccess = false;
      try {
        const res = await ApiService.query("/budgets", {
          params: {
            financial_year_id: this.filters.financial_year_id || undefined,
            status: this.filters.status || undefined,
            per_page: this.filters.per_page || undefined,
          },
        });
        this.items = Array.isArray(res.data?.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        if (e?.response?.status === 403) {
          this.noAccess = true;
        }
        this.items = [];
      } finally {
        this.isBusy = false;
      }
    },
    async loadFinancialYears() {
      try {
        const res = await ApiService.get("/setup/financial-years/all");
        this.financialYears = res.data?.data || [];
      } catch (e) {
        this.financialYears = [];
      }
    },
  },
};
</script>

